/**
 *
 *   APPLICATION CONSTANTS
 *
 */

export const SET_LOADING: string = "SET_LOADING";
export const RESET_LOADING: string = "RESET_LOADING";

export const SET_MESSAGE: string = "SET_MESSAGE";
export const RESET_MESSAGE: string = "RESET_MESSAGE";
export const REMOVE_MESSAGE: string = "REMOVE_MESSAGE";

/** Artists Constants */
export const GET_ARTISTS: string = "GET_ARTISTS";
export const SET_ARTISTS: string = "SET_ARTISTS";
